<template>
  <div>
    <popup
        :elevated-z-index="5000"
        @close="$emit('abort')"
    >
      <div slot="popupMainContent">
        <h1>{{ $t('editType', {type: $t(storeName.toLowerCase())}) }}</h1>
        <div v-if="metaSets" class="row">
          <meta-panel
              v-for="(item) in metaSets"
              :key="item.id"
              :cid="instanceId"
              :id="projectId"
              :target-id="projectId"
              :fields="item.metaFields"
              :initially-collapsed="false"
              :organization-ids="[organizationId]"
              :store-name="storeName + 'Instance'"
              :title="item.description"
              class="col-12 col-md-6 col-xl-10 col-xxl-8"
              icon-left="folder"
              @updated="load"
          />
        </div>
      </div>
    </popup>
  </div>
</template>

<script>
import Popup from "../Popup";
import MetaPanel from "../widgets/meta/MetaPanel";
import {combineAssetAndInstanceMetaValues} from "@/utils";

export default {
  name: "EditInstanceForm",
  components: {
    Popup,
    MetaPanel,
  },
  props: {
    instanceId: {type: String, required: true},
    organizationId: {type: String, required: true},
    projectId: {type: String, required: true},
    storeName: {type: String, required: true},
  },
  data() {
    return {
      listName: this.projectId + 'SingleInstance',
      title: '',
      description: '',
      enableSaving: false,
      metaSets: null,
    };
  },
  watch: {
    title() {
      if (this.title.length > 0) {
        this.enableSaving = true;
      }
    },
  },
  beforeMount() {
    this.load();
  },
  methods: {
    load() {
      this.$store.dispatch('load' + this.storeName + 'Instance', {
        id: this.projectId,
        cid: this.instanceId,
        listName: this.listName,
        include: ['assetAndMetaSetsBugfix', 'metaValues'],
      }).then(instance => {
        this.metaSets = combineAssetAndInstanceMetaValues(instance.asset.metaSets, instance.metaValues);
      });
    },
  },
}
</script>